var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0371 7.52018V26.9211C24.0371 28.2463 24.8468 29.4406 26.077 29.9491C27.3149 30.4576 28.7398 30.1725 29.6818 29.2402L42.7698 16.2883C43.3927 15.6719 43.7353 14.8398 43.7353 13.9692C43.7353 13.0985 43.3849 12.2664 42.7698 11.65L33.8395 2.8125C31.5427 5.67101 28.0079 7.50477 24.0371 7.51248V7.52018Z",
    fill: "url(#paint0_linear_1522_156)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.706 7.51237V26.9133C22.706 28.2385 21.8962 29.4328 20.6661 29.9413C19.4281 30.4498 18.0033 30.1647 17.0612 29.2324L3.96544 16.2805C3.35036 15.6641 3 14.832 3 13.9614C3 13.0907 3.35036 12.2586 3.96544 11.6422L12.9036 2.80469C15.2004 5.6632 18.7352 7.49696 22.706 7.50466V7.51237Z",
    fill: "#225CA6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_156",
    x1: 31.2322,
    y1: 0.322862,
    x2: 31.2322,
    y2: 59.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.99cdc3b31cb5e964a30a5f6636f180b3.svg";
export { ForwardRef as ReactComponent };